module.exports = __webpack_public_path__ + "assets/task-image.e1ca662b.svg";